import { Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  formatDate,
  formatTime,
  FormattedDate,
} from "../../../../helper/converters";
import { useLoginState } from "../../../../hooks/loginInfo";
import Avatar from "../../avatar";
import "./index.scss";

const defaultImage =
  "https://cinemahive.s3.amazonaws.com/images/logos/Project+%E2%80%93+1.png";

const ItemCallSheet = (props: any) => {
  const { item, send, onOpenParticipant } = props;
  const params = useParams();
  const onlyDate = item.date.split(" ");
  const dateCard = formatDate(onlyDate[0] + "T00:00:00");
  const today = new Date().toISOString().substr(0, 19).replace("T", " ");
  const [canEditing] = useState(useLoginState().can_edit.get());
  const onlyTodayDate = today.split(" ");

  const isActive =
    Date.parse(FormattedDate(onlyTodayDate[0])) <= Date.parse(onlyDate[0]);

  return (
    <Card
      sx={{
        width: "100%",
        padding: 0,
        textDecoration: "none",
        marginBottom: "2rem",
        opacity: isActive ? 1 : 0.5,
      }}
    >
      <CardContent className="callsheet-card">
        <Grid
          container
          className="callsheet-container"
        >
          <Grid
            item
            xs={2}
            className="callsheet-image"
          >
            <Avatar
              url={item.project?.client_logo_url ?? defaultImage}
              style={{
                width: "103px",
                height: "103px",
                borderRadius: "9px",
              }}
            />
          </Grid>
          <Grid
            item
            xs={4}
            className="callsheet-information"
          >
            <Box
              sx={{
                textAlign: "center",
              }}
            >
              <Typography
                variant="h3"
                sx={{ fontWeight: "bold" }}
              >
                {item.title}
              </Typography>
              <Typography
                variant="body1"
                component="p"
                className="callsheet-information--subtitle"
              >
                General Call Time
              </Typography>
              <Typography
                variant="h1"
                component="p"
              >
                {formatTime(item.time)}
              </Typography>
            </Box>
          </Grid>

          {
            canEditing && <Grid
              item
              xs={1}
              className="callsheet-link"
            >
              <a
                href={`/project/${params.projectId}/call-sheet/edit/${item.id}`}
                className={!isActive ? "disabled" : ""}
              >
                EDIT
              </a>
            </Grid>
          }
          {
            !canEditing && item.file_url && <Grid
              item
              xs={1}
              className="callsheet-link"
            >
              <a
                href={item.file_url}
                target='_blank'
              >
                VIEW
              </a>
            </Grid>
          }
          <Grid
            item
            xs={3}
            className="callsheet-date"
          >
            <Box
              sx={{
                textAlign: "center",
              }}
            >
              <Typography
                variant="h4"
                component="h4"
              >
                {dateCard}
              </Typography>
              <Typography component="p">
                Day <span>{item.day_start || 0}</span>/
                <span>{item.day_final || 0}</span>
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={2}
            className="callsheet-button"
          >
            {item.send && (
              <Button
                variant="contained"
                disabled={isActive ? false : true}
                sx={{
                  mt: 3,
                  color: "black",
                  display: "block",
                  height: "fit-content",
                  width: "100%",
                  lineHeight: 1,
                }}
                onClick={() => onOpenParticipant(item.id)}
              >
                Confirmed
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ fontWeight: "bold", display: "block" }}
                >
                  {`${item.confirmed_participants} OF ${item.total_participants}`}
                </Typography>
              </Button>
            )}
            {(!item.send && canEditing) && (
              <Button
                variant="contained"
                disabled={isActive ? false : true}
                sx={{
                  color: "black",
                  display: "block",
                  height: "fit-content",
                  width: "100%",
                  lineHeight: 1,
                }}
                className="btn-send"
                onClick={() => send(item)}
              >
                Send
              </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ItemCallSheet;
